import { PARAM_SAVEONFIRSTRENDER } from "./constants"

export const makeLoginUrl = (returnUrl: string, region: string, isSignup: boolean, shouldResume: boolean ) => {
    const verb = isSignup ? 'signup' : 'login'
    const baseUrl = `https://www.ikea.com/${region}/profile/${verb}/`
    const fromUrl = new URL(returnUrl)
    if (shouldResume) {
        fromUrl.searchParams.set('resume', 'true')
        fromUrl.searchParams.set(PARAM_SAVEONFIRSTRENDER, 'true')
    }
    return `${baseUrl}?from=${window.encodeURIComponent(fromUrl.toString())}`
}
